if (!customElements.get('full-ingredient-list')) {
  customElements.define(
    'full-ingredient-list',
    class FullIngredientList extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-full-ingredient-list-toggle]');
        this.expander = this.querySelector('[data-full-ingredient-list-expander]');

        if (!this.toggle || !this.expander) {
          return;
        }

        this.onToggle = () => {
          const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';
          const nextState = !isExpanded;

          this.toggle.setAttribute('aria-expanded', nextState ? 'true' : 'false');
          this.expander.classList.toggle('is-expanded', nextState);
          this.toggle.classList.toggle('is-expanded', nextState);
        };

        this.toggle.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        if (this.toggle && this.onToggle) {
          this.toggle.removeEventListener('click', this.onToggle);
        }
      }
    }
  );
}
